import React from 'react';
import { Route } from 'react-router';
import { logout } from '../../core/actions/user/logout';
import { getStore } from '../store';
import Raven from '../utils/raven';
import { redirectToGeneralAfterLogOut } from '../utils/redirectToGeneral';

const logoutRoute = (
  <Route
    path="logout"
    onEnter={() => {
      const store = getStore();
      store.dispatch(logout()).then((err) => {
        if (err) {
          Raven.captureException(err, {
            tags: {
              context: 'logout',
            },
          });
        }

        localStorage.clear();

        redirectToGeneralAfterLogOut();
      });
    }}
  />
);

export default logoutRoute;
